import { parser } from "@/utils/parser";

export const state = () => ({
  routes: [],
  meta: null,
  pending: false,
  query: '',
  page: 1,
  count: 12,
  city_id: null,
  category_id: null,
  categories: [],
  categoriesForCheckbox: [],
  season_id: null,
  level_id: null,
  age_restriction_id: null,
  accessible_environment: false,
  tourism_type_id: null,
  promo: false,
  sort: 'avg',
  lang: null
})

export const mutations = {
  clear: (state) => {
    state.routes = []
    state.meta = null
  },
  reset: (state) => {
    state.routes = []
    state.meta = null
    state.query = ''
    state.page = 1
    state.city_id = null
    state.accessible_environment = false
    state.sort = 'avg'
    state.promo = false
    state.tourism_type_id = null
    state.season_id = null
    state.level_id = null
    state.age_restriction_id = null
    state.categoriesForCheckbox = state.categoriesForCheckbox.map(item => ({...item, checked: false}))
  },
  setCategories: (state, categories) => {
    state.categories = categories
    if (state.categoriesForCheckbox.length === 0) {
      state.categoriesForCheckbox = categories.map(item => ({
        id: item.id,
        title: item.title,
        checked: false
      }))
    }
  },
  setCategoryIdFromString: (state, categoryString) => {
    if (categoryString) {
      const array = categoryString.split(',');
      array.forEach(id => {
        state.categoriesForCheckbox.forEach(item => {
          if (Number(item.id) === Number(id)) {
            item.checked = true
          }
        })
      })
    } else {
      state.categoriesForCheckbox.forEach(item => item.checked = false)
    }
  },
  setCategoriesForCheckbox: (state, categoriesForCheckbox) => state.categoriesForCheckbox = categoriesForCheckbox,
  setRoutes: (state, routes) => state.routes = [...state.routes, ...routes],
  setMeta: (state, meta) => state.meta = meta,
  setCityId: (state, city_id) => state.city_id = city_id,
  setQuery: (state, query) => state.query = query,
  setPage: (state, page) => state.page = page,
  setCount: (state, count) => state.count = count,
  setPending: (state, pending) => state.pending = pending,
  setPromo: (state, promo) => {
    promo === 'true' || promo === true ?
      state.promo = true :
      state.promo = false
  },
  setLevelId: (state, level_id) => state.level_id = level_id ? Number(level_id) : null,
  setSeasonId: (state, season_id) => state.season_id = season_id ? Number(season_id) : null,
  setTourismTypeId: (state, tourism_type_id) => state.tourism_type_id = tourism_type_id ? Number(tourism_type_id) : null,
  setSort: (state, sort) => {
    sort === 'avg' || sort === 'created_at' ? state.sort = sort : state.sort = 'avg'
  },
  setAgeRestrictionId: (state, age_restriction_id) => state.age_restriction_id = age_restriction_id ? Number(age_restriction_id) : null,
  setAccessibleEnvironment: (state, accessible_environment) => {
    accessible_environment === 'true' || accessible_environment === true ?
      state.accessible_environment = true :
      state.accessible_environment = false
  },
  setLang: (state, lang) => state.lang = lang,
}

export const actions = {
  async search({commit, state}, payload) {
    commit('setPending', true)
    if (payload?.clear) {
      commit('clear')
    }
    await this.$axios.$get(`/api/search/routes?${parser({
      params: {
        city_id: state.city_id,
        query: state.query,
        count: state.count,
        page: state.page,
        resolution: 'micro',
        lang: state.lang,
      }
    })}`)
      .then((resolve) => {
        commit('setRoutes', resolve.data)
        commit('setMeta', resolve.meta)
      })
      .catch(() => null)
      .finally(() => commit('setPending', false))
  },
  async routes({state, commit}, payload) {
    commit('setPending', true)
    if (payload?.clear) {
      commit('clear')
    }
    await this.$axios.$get(`/api/routes?${parser({
      params: {
        resolution: 'micro',
        city_id: state.city_id,
        season_id: state.season_id,
        level_id: state.level_id,
        age_restriction_id: state.age_restriction_id,
        tourism_type_id: state.tourism_type_id,
        promo: state.promo,
        accessible_environment: state.accessible_environment,
        sort: state.sort,
        page: state.page,
        count: state.count,
        lang: state.lang,
        category_id: state.categoriesForCheckbox.filter(item => item.checked === true).map(item => item.id).join(','),
      }
    })}`)
      .then(response => {
        commit('setRoutes', response.data)
        commit('setMeta', response.meta)
      })
      .catch(() => null)
      .finally(() => commit('setPending', false))
  }
}

export const getters = {
  routes: state => state.routes,
  meta: state => state.meta,
  pending: state => state.pending,
  query: state => state.query,
  page: state => state.page,
  count: state => state.count,
  city_id: state => state.city_id,
  category_id: state => state.category_id,
  season_id: state => state.season_id,
  level_id: state => state.level_id,
  age_restriction_id: state => state.age_restriction_id,
  accessible_environment: state => state.accessible_environment,
  tourism_type_id: state => state.tourism_type_id,
  promo: state => state.promo,
  sort: state => state.sort,
  categoriesForCheckbox: state => state.categoriesForCheckbox,
}
